import gql from "graphql-tag";
import { useQuery, QueryHookOptions } from "@apollo/client";

const REQUEST_STREAM_GAME_DATA = gql`
  query ($game: String!) {
    twitchStreams(game: $game) {
      id
      userId
      userLogin
      userName
      gameId
      gameName
      type
      title
      viewerCount
      startedAt
      language
      profileImageUrl
      thumbnailUrl
      tagIds
      tags
      isMature
    }
  }
`;

export function getTwitchStreams(game: string, queryOptions: QueryHookOptions = {}) {
  return useQuery(REQUEST_STREAM_GAME_DATA, {
    ...queryOptions,
    variables: {
      game,
    },
  });
}
